import { Box, Skeleton, styled } from '@mui/material';
import React from 'react';

interface SectionSkeletonProps {
  height?: number;
  width?: number;
}

const StyledRoot = styled('div')<SectionSkeletonProps>(
  ({ width = 310, height = 100 }) => ({
    margin: '0px 20px',

    '& .title': {
      display: 'flex',
      alignItems: 'start'
    },

    '& .titleIcon': {
      width: 30,
      height: 30,
      margin: '25px 0px',
      transform: 'none'
    },

    '& .titleLabel': {
      width: 110,
      height: 30,
      margin: '25px 15px',
      transform: 'none'
    },

    '& .content': {
      display: 'flex',
      alignItems: 'start'
    },

    '& .contentSkeleton': {
      width,
      height,
      margin: '0px 0px 32px 45px',
      transform: 'none'
    }
  })
);

export const SectionSkeleton: React.FC<SectionSkeletonProps> = ({
  height = 100,
  width = 310
}) => {
  return (
    <StyledRoot width={width} height={height}>
      <Box className="title">
        <Skeleton className="titleIcon" />
        <Skeleton className="titleLabel" />
      </Box>
      <Box className="content">
        <Skeleton className="contentSkeleton" />
      </Box>
    </StyledRoot>
  );
};
